// extracted by mini-css-extract-plugin
module.exports = {"ware-parameter":"_1U1DA4lH1s","title-top":"_2b-8wEpOB_","title-section":"_26UASEMjQW","table-section":"_1sTqDNxtJK","add-btn":"_2zKNpqcLqg","expanded-table":"cc0-Lx1anU"};